module.exports = __webpack_public_path__ + "static/img/cover.94ff243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/cover.jpg
// module id = dFRf
// module chunks = 0